<div>
	<div class="form" style="z-index: 10;">
        <div class="form-group">
            <div class="field field--text field--required">
                <label class="field-label" for="email">Benutzername</label>
                <input id="email" bind:value={email} class="field-control" type="text" required autocomplete="off">
            </div>
            <div class="field field--text field--required">
                <label class="field-label" for="password">Passwort</label>
                <input id="password" bind:value={password} class="field-control" type="password" required autocomplete="off">
            </div>
        </div>
        <div class="panel-login">
            <button id=buttonLogin class="btn-primary btn-primary-circle icon-right-to-bracket" onclick={start_login}>login</button>
            <span>oder jetzt <a class="link-register text-button" data-help="register" onclick={show_register}>registrieren</a></span>
        </div>
	</div>
</div>
<RegisterDialog />
<!-- ToDo: brauchen wir noch einen Info-Knopf und Platz für eine Fehlermeldung? -->

<script>
		import { user } from "../client.svelte.js"
		import RegisterDialog, {show_register} from "../dialogs/RegisterDialog.svelte"

		let email = $state("")
		let password = $state("")

		async function start_login() {
        if (!(email && password)) {   // require both, email and password
            alert(`Bitte gib Deinen Nutzernamen und Dein Passwort an!`)
            return
        }
        user.login(email, password)
	}
</script>


<style lang="sass">
	@use "../colors" as colors

	.form
		position: absolute
		right: 0
		padding: 0 48px
		display: flex
		flex-flow: row nowrap
		background-color: #252626
		height: 85px

	.form-group
		display: flex
		flex-flow: row nowrap

	.field
		display: flex
		flex-flow: column nowrap
		margin: 15px 10px 10px 10px
		width: 180px

	.field-label
		color: colors.$white

	.field-control
		margin: 5px 0
		background-color: #9C9797
		border: none
		border-radius: 5px
		color: black

	.panel-login
		padding-top: 15px
		display: flex
		flex-flow: row nowrap
		align-items: center
		gap: 20px

	.link-register
		font-weight: bold
		text-decoration: underline
		text-decoration-thickness: 1px

</style>